module.exports = __webpack_public_path__ + "img/logo.a762a24c.png";